import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "pa-4" };
const _hoisted_2 = { class: "hint mb-2" };
const _hoisted_3 = { class: "hint mb-2" };
const _hoisted_4 = { class: "hint mb-2" };
const _hoisted_5 = {
    key: 0,
    class: "hint mt-6"
};
import { ref } from 'vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import { vibrate, enableNotifications, setCreds } from '../utils/native';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChannelsPage',
    setup(__props) {
        const pin = ref('');
        const email = ref('');
        const password = ref('');
        const lastSent = ref('');
        const popView = ref('logout');
        function status(channel) {
            return window[channel] ? 'channel available' : 'channel NOT available (web browser?)';
        }
        function pop() {
            window.location.href = `MG_POP.html?view=${popView.value}`;
        }
        function fire(channel, message, send) {
            send();
            lastSent.value = `${channel}.postMessage('${message}')`;
        }
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "JS Channels",
                    backButton: false
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "mb-2" }, "Vibration", -1)),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(status('Vibration')), 1),
                    _createVNode(MGButton, {
                        text: "Vibrate",
                        fullWidth: true,
                        class: "mb-6",
                        onClick: _cache[0] || (_cache[0] = ($event) => (fire('Vibration', 'vibrate', () => _unref(vibrate)())))
                    }),
                    _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "mb-2" }, "enableNotifications", -1)),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(status('enableNotifications')), 1),
                    _createVNode(MGButton, {
                        text: "Enable notifications",
                        fullWidth: true,
                        class: "mb-6",
                        onClick: _cache[1] || (_cache[1] = ($event) => (fire('enableNotifications', '', _unref(enableNotifications))))
                    }),
                    _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "mb-2" }, "setCreds", -1)),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(status('setCreds')), 1),
                    _createVNode(_component_v_text_field, {
                        modelValue: pin.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((pin).value = $event)),
                        label: "PIN",
                        density: "compact",
                        variant: "outlined"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((email).value = $event)),
                        label: "Email",
                        density: "compact",
                        variant: "outlined"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((password).value = $event)),
                        label: "Password",
                        density: "compact",
                        variant: "outlined"
                    }, null, 8, ["modelValue"]),
                    _createVNode(MGButton, {
                        text: "Set creds",
                        fullWidth: true,
                        onClick: _cache[5] || (_cache[5] = ($event) => (fire('setCreds', [pin.value, email.value, password.value].join('__'), () => _unref(setCreds)(pin.value, email.value, password.value))))
                    }),
                    _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mb-2 mt-6" }, "MG_POP", -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "hint mb-2" }, "Navigates to MG_POP.html, as the logout flow does.", -1)),
                    _createVNode(_component_v_text_field, {
                        modelValue: popView.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((popView).value = $event)),
                        label: "view",
                        density: "compact",
                        variant: "outlined"
                    }, null, 8, ["modelValue"]),
                    _createVNode(MGButton, {
                        text: "Pop",
                        fullWidth: true,
                        onClick: _cache[7] || (_cache[7] = ($event) => (pop()))
                    }),
                    (lastSent.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                            _cache[8] || (_cache[8] = _createTextVNode("Last sent: ")),
                            _createElementVNode("code", null, _toDisplayString(lastSent.value), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
